import * as React from 'react';
import {BatchRow} from '../../Config/dataModel';
import BatchRecordTableView from './BatchRecordTableView';

interface BatchRecordProps {
    stage: string,
    validRecords: BatchRow[],
    csvDuplicateError: BatchRow[],
    dltDuplicateError: BatchRow[],
    incompleteError: BatchRow[]
}

class BatchRecord extends React.Component <BatchRecordProps, {}> {
    public render() {
        return (
            <div>
                {this.props.validRecords.length ?
                    <BatchRecordTableView
                        stage={this.props.stage}
                        records={this.props.validRecords}
                        title="Valid record"/> : null}
                {this.props.csvDuplicateError.length ?
                    <BatchRecordTableView
                        stage={this.props.stage}
                        records={this.props.csvDuplicateError}
                        title="Duplicated record found"/> : null}
                {this.props.dltDuplicateError.length ?
                    <BatchRecordTableView
                        stage={this.props.stage}
                        records={this.props.dltDuplicateError}
                        title="Duplicated record found in DLT"/> : null}
                {this.props.incompleteError.length ?
                    <BatchRecordTableView
                        stage={this.props.stage}
                        records={this.props.incompleteError}
                        title="Invalid record found"/> : null}
            </div>
        );
    }
}

export default BatchRecord;



// WEBPACK FOOTER //
// ./src/Components/Batch/BatchRecord.tsx